module.exports = __webpack_public_path__ + "99ebf80b16810bd0259ea25530064ad0.png";